/*

TODO:...

scenarios:

1. Going back, then moving forwards
  - you can't click on the steps to go forward, but you can go through the steps again
  - the steps should show as it's been completed but you can still go forward

complete-future
complete-past

*/

import styled from '@emotion/styled'
import * as React from 'react'

import { SimpleTabStrip, Space, StepStateName } from '../../../../../components/core-v2'
import StepTab from '../../../../../components/core-v2/molecules/step-tab'
import { StepName } from '../state/builder-slice'

export type Props = {
  children: React.ReactNode
  currentStepName: StepName
  onGoToStep: (stepName: StepName) => void
}

const stepMap = new Map<StepName, number>()
stepMap.set('note', 1)
stepMap.set('terms', 2)
stepMap.set('portfolio', 3)
stepMap.set('strategy', 4)
stepMap.set('complete', 5)

const getState = (stepName: StepName, currentStep: StepName): StepStateName => {
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  const currentIndex = stepMap.get(currentStep)!
  const stepIndex = stepMap.get(stepName)!
  /* eslint-enable @typescript-eslint/no-non-null-assertion */

  if (currentIndex < stepIndex) {
    return 'pending'
  }

  if (currentIndex > stepIndex) {
    return 'complete'
  }

  if (currentIndex === stepIndex) {
    return 'current'
  }
}

const StyledWrapper = styled.div`
  background-color: var(--White);
`

const StyledTabsWrapper = styled.div`
  border-bottom: 1px solid var(--White80);
`

export function WizardLayout({ children, currentStepName, onGoToStep }: Props) {
  const renderTab = (tabName: string, tabPosition: number, stepName: StepName) => (
    <StepTab
      isSelected={currentStepName === stepName}
      state={getState(stepName, currentStepName)}
      stepNumber={tabPosition}
      onClick={() => onGoToStep(stepName)}
    >
      {tabName}
    </StepTab>
  )

  return (
    <StyledWrapper>
      <StyledTabsWrapper>
        <Space isflex flexDirection="row" px={5}>
          <SimpleTabStrip showRule={false}>
            {renderTab('Note', 1, 'note')}
            {renderTab('Trade terms', 2, 'terms')}
            {renderTab('Portfolio', 3, 'portfolio')}
            {renderTab('Strategy', 4, 'strategy')}
            {renderTab('Complete', 5, 'complete')}
          </SimpleTabStrip>
        </Space>
      </StyledTabsWrapper>
      <div>{children}</div>
    </StyledWrapper>
  )
}
